"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLog = exports.LogProvider = exports.LogContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const log_1 = require("../network/log");
const use_lazy_promise_1 = require("../hook/use-lazy-promise");
exports.LogContext = (0, react_1.createContext)({});
const LogProvider = ({ children, }) => {
    const { execute: executeLogEvent } = (0, use_lazy_promise_1.useLazyPromise)(log_1.logEvent);
    const generateCommonParams = (0, react_1.useCallback)(() => {
        return {
            timestamp: new Date().getTime(),
        };
    }, []);
    const handleLogEvent = (0, react_1.useCallback)((type, name, params) => {
        executeLogEvent(Object.assign({ eventType: type, eventName: name }, generateCommonParams()), params);
    }, [executeLogEvent, generateCommonParams]);
    const value = (0, react_1.useMemo)(() => ({
        logEvent: handleLogEvent,
    }), [handleLogEvent]);
    return (0, jsx_runtime_1.jsx)(exports.LogContext.Provider, { value: value, children: children });
};
exports.LogProvider = LogProvider;
const useLog = () => (0, react_1.useContext)(exports.LogContext);
exports.useLog = useLog;
